<div class="flex min-w-0 flex-auto flex-col">
  <!-- Header -->
  <div class="bg-card">
    <div class="mx-auto flex w-full max-w-screen-xl flex-col px-6 sm:px-8">
      <div
        class="my-8 flex min-w-0 flex-auto flex-col sm:my-12 sm:flex-row sm:items-center">
        <!-- Avatar and name -->
        <div class="flex min-w-0 flex-auto items-center">
          <div class="h-16 w-16 flex-0 overflow-hidden rounded-full">
            <img
              class="h-full w-full object-cover"
              src="images/avatars/brian-hughes.jpg" />
          </div>
          <div class="ml-4 flex min-w-0 flex-col">
            <ng-container *transloco="let t">
              <div
                class="truncate text-2xl font-semibold leading-7 tracking-tight md:text-5xl md:leading-snug">
                {{ 'WelcomeBack' | transloco }}, {{authService.user?.Name}}
              </div>
            </ng-container>
          </div>
        </div>
      </div>
      <!-- Project selector -->
      <div
        class="bg-default relative flex cursor-pointer self-start overflow-hidden rounded-t-xl border border-b-0 pb-1 pl-5 pr-4 pt-2"
        matRipple>
        <div class="flex items-center">
          <div class="overflow-hidden">
            <div class="truncate font-medium leading-6">
              {{'SalesOverview' | transloco}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Main -->
  <div class="-mt-px flex-auto border-t pt-4 sm:pt-6">
    <div class="mx-auto w-full max-w-screen-xl">
      <!-- Tabs -->
      <mat-tab-group
        class="sm:px-2"
        mat-stretch-tabs="false"
        [animationDuration]="'0'"
        [(selectedIndex)]="selectedTabIndex">
        <!-- Summary -->
        <mat-tab [label]="'Summary' | transloco">
          <ng-template matTabContent>
            <div
              class="grid w-full min-w-0 grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-4">
              <!-- Summary -->
              <div
                class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl p-6 shadow cursor-pointer">
                <div class="flex items-start justify-between">
                  <div
                    class="truncate w-100 text-lg font-medium leading-6 tracking-tight">
                    {{'ReservedVehicles' | transloco}}
                  </div>
                </div>
                <div class="mt-5 flex flex-col items-center">
                  <div
                    class="text-7xl font-bold leading-none tracking-tight text-teal-600 sm:text-8xl">
                    {{getReservedVehiclesCount}}
                  </div>
                </div>
              </div>
              <div
                class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl p-6 shadow cursor-pointer">
                <div class="flex items-start justify-between">
                  <div
                    class="truncate w-100 text-lg font-medium leading-6 tracking-tight">
                    {{'ContractsInProgress' | transloco}}
                  </div>
                </div>
                <div class="mt-5 flex flex-col items-center">
                  <div
                    class="text-7xl font-bold leading-none tracking-tight text-amber-500 sm:text-8xl">
                    {{getContractsInProgressCount}}
                  </div>
                  <div
                    class="text-secondary mt-5 flex w-full items-baseline justify-center">
                    <div
                      class="truncate text-md font-medium">
                      {{'AwaitingDocs' | transloco}}
                    </div>
                    <div
                      class="ml-1.5 text-lg font-semibold">
                      {{getContractsWithNoDocs}}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl p-6 shadow">
                <div class="flex items-start justify-between">
                  <div
                    class="truncate w-100 text-lg font-medium leading-6 tracking-tight">
                    {{'Sold' | transloco}} {{'Vehicles' | transloco}}
                    {{soldCarsPeriod | transloco}}
                  </div>
                  <div class="-mr-3 -mt-2 ml-2">
                    <button
                      mat-icon-button
                      [matMenuTriggerFor]="featuresMenu">
                      <mat-icon
                        class="icon-size-5"
                        [svgIcon]="
                                                    'heroicons_mini:ellipsis-vertical'
                                                "></mat-icon>
                    </button>
                    <mat-menu #featuresMenu="matMenu">
                      <button mat-menu-item
                        (click)="soldCarsTimePeriod.set('Last 7 Days')">
                        {{'Last7Days' | transloco}}
                      </button>
                      <button mat-menu-item
                        (click)="soldCarsTimePeriod.set('Last 30 Days')">
                        {{'Last30Days' | transloco}}
                      </button>
                      <button mat-menu-item
                        (click)="soldCarsTimePeriod.set('Last Year')">
                        {{'LastYear' | transloco}}
                      </button>
                    </mat-menu>
                  </div>
                </div>
                <div class="mt-3 flex flex-col items-center">
                  <div
                    class="text-7xl font-bold leading-none tracking-tight text-green-500 sm:text-8xl">
                    {{getSoldCarsCount}}
                  </div>

                  <div
                    class="text-secondary mt-5 flex w-full items-baseline justify-center">
                    <div
                      class="truncate text-md font-medium">
                      {{'Delivered' | transloco}}
                    </div>
                    <div
                      class="ml-1.5 text-lg font-semibold">
                      {{getDeliveredCarsCount}}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl p-6 shadow">
                <div class="flex items-start justify-between">
                  <div
                    class="truncate w-100 text-lg font-medium leading-6 tracking-tight">
                    {{'PendingDeliveries' | transloco}}
                  </div>
                </div>
                <div class="mt-4 flex flex-col items-center">
                  <div
                    class="text-7xl font-bold leading-none tracking-tight text-blue-500 sm:text-8xl">
                    {{getPendingDeliveriesCount}}
                  </div>
                </div>
                <div
                  class="text-secondary mt-5 flex w-full items-baseline justify-center">
                  <div
                    class="truncate text-md font-medium">
                     {{'My' | transloco}} {{'PendingDeliveries' | transloco}}
                  </div>
                  <div
                    class="ml-1.5 text-lg font-semibold">
                    {{getUserPendingDeliveriesCount}}
                  </div>
                </div>
              </div>

              <div
                class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl p-6 shadow sm:col-span-2 md:col-span-2">
                <div
                  class="flex flex-col items-start justify-between sm:flex-row">
                  <div
                    class="truncate text-lg font-medium leading-6 tracking-tight">
                    {{'Contracts' | transloco}}
                  </div>
                  <div class="mt-3 sm:ml-2 sm:mt-0">
                    <mat-button-toggle-group
                      value="this-week"
                      #githubIssuesWeekSelector="matButtonToggleGroup">
                      <!-- <mat-button-toggle value="last-week">Last
                        Week</mat-button-toggle> -->
                      <mat-button-toggle value="this-week">
                        {{'Last30Days' | transloco}}
                      </mat-button-toggle>
                    </mat-button-toggle-group>
                  </div>
                </div>
                <div
                  class="mt-8 grid w-full grid-flow-row">
                  <!-- New vs. Closed -->
                  <div class="flex flex-auto flex-col">
                    <div class="flex flex-auto flex-col">
                      <apx-chart
                        class="h-80 w-full flex-auto"
                        [chart]="
                                                    chartGithubIssues.chart
                                                "
                        [colors]="
                                                    chartGithubIssues.colors
                                                "
                        [dataLabels]="
                                                    chartGithubIssues.dataLabels
                                                "
                        [grid]="chartGithubIssues.grid"
                        [labels]="
                                                    chartGithubIssues.labels
                                                "
                        [legend]="
                                                    chartGithubIssues.legend
                                                "
                        [plotOptions]="
                                                    chartGithubIssues.plotOptions
                                                "
                        [series]="
                                                    chartGithubIssues.series
                                                "
                        [states]="
                                                    chartGithubIssues.states
                                                "
                        [stroke]="
                                                    chartGithubIssues.stroke
                                                "
                        [tooltip]="
                                                    chartGithubIssues.tooltip
                                                "
                        [xaxis]="
                                                    chartGithubIssues.xaxis
                                                "
                        [yaxis]="
                                                    chartGithubIssues.yaxis
                                                "></apx-chart>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="bg-card flex flex-auto flex-col overflow-hidden rounded-2xl p-6 shadow sm:col-span-2 md:col-span-2 lg:col-span-2">
                <div
                  class="flex flex-col items-start justify-between sm:flex-row">
                  <div
                    class="truncate text-lg font-medium leading-6 tracking-tight">
                    {{'MySchedule' | transloco}}
                  </div>
                </div>
                <!-- Fixed height + scroll -->
                <div class="mt-2 flex flex-col divide-y h-96 overflow-y-auto">
                  @for (
                  scheduleItem of data()?.schedules;
                  track trackByFn($index, scheduleItem)
                  ) {
                  <div
                    class="flex flex-row items-center justify-between px-0.5 py-4">
                    <div class="flex flex-col">
                      <div class="font-medium">
                        {{ scheduleItem.description }}
                        test: {{scheduleItem.deliveryType}}
                      </div>
                      <div
                        class="-ml-0.5 mt-2 flex flex-col space-y-1 sm:mt-1 sm:flex-row sm:items-center sm:space-x-3 sm:space-y-0">

                        @if (scheduleItem.time || scheduleItem.date) {
                        <div class="flex items-center">
                          <mat-icon
                            class="text-hint icon-size-5"
                            [svgIcon]="'heroicons_solid:clock'"></mat-icon>
                          <div class="text-secondary ml-1.5 text-md">
                            {{ scheduleItem.date | date: 'longDate' }}
                          </div>
                          <div class="text-secondary ml-1.5 text-md">
                            {{ scheduleItem.time }}
                          </div>
                        </div>
                        }

                        @if (scheduleItem.type) {
                        <div class="flex items-center">
                          <mat-icon
                            class="text-hint icon-size-5"
                            [svgIcon]="'heroicons_solid:information-circle'"></mat-icon>
                          <div class="text-secondary ml-1.5 text-md">
                            {{ scheduleItem.type }}
                          </div>
                        </div>
                        }
                      </div>
                    </div>
                  </div>
                  }
                </div>
              </div>
            </div>
          </ng-template>
        </mat-tab>

        <!-- <mat-tab label="Delivery Calendar">
          <ng-template matTabContent>
            <app-delivery-calendar-salesperson></app-delivery-calendar-salesperson>
          </ng-template>
        </mat-tab>

        <mat-tab label="Contracts In Progress List">
          <ng-template matTabContent>
            <app-contracts-in-progress-salesperson></app-contracts-in-progress-salesperson>
          </ng-template>
        </mat-tab>

        <mat-tab label="Reserved Vehicles List">
          <ng-template matTabContent>
            <app-vehicles-i-reserved></app-vehicles-i-reserved>
          </ng-template>
        </mat-tab> -->

      </mat-tab-group>
    </div>
  </div>
</div>

